import { defineStore } from 'pinia';
import _ from 'lodash';

const path = import.meta.env.VITE_APP_URL + 'account/location';
import { useKeycloakStore } from './keycloak.js';
// console.log('$lcStorage', this.$lcStorage);
export const useLocationStore = defineStore('location', {
  state: () => ({
    country:'',
    cityList: '',
    stateList: '',
    countryStates: '',
    countryList: '',
    destinationCity: '',
    userAddress: '',
    currentUserCountry: '',
    latitude: '',
    longitude: '',
    ipAddress: '',
    currencyList: [],
    emoneyApiList:  [],
    apiCode:  {},
    phoneNumberDetail: '',
    mobilePhoneError: '',
  }),
  persist: true,

  getters: {
    allCountriesByCountryId: (state) => _.groupBy(state.country, 'countryId'),
    allCountriesByCountryName: (state) => _.groupBy(state.country, 'countryName'),
    allCountriesByCountryCode2: (state) => _.groupBy(state.country, 'countryCode2'),
  },

  actions: {
    async getCountry() {
      const { default: axios } = await import('axios');
      try {
        const { data: country } = await axios.get(`${path}/allCountries`);
        this.country = country;
        console.log('country', country);
        this.$lcStorage?.set('L5ET4juMXyWmUgzY9', this.country);
      } catch (err) {
        console.log(err);
      }
    },

    setCountries(payload) {
      this.country = payload;
      this.$lcStorage?.set('L5ET4juMXyWmUgzY9', this.country);
    },

    async getCountryStates() {
      const { default: axios } = await import('axios');
      try {
        const { data: countryStates } = await axios.get(`${path}/allStates`);
        this.countryStates = countryStates;
      } catch (err) {
        console.log(err);
      }
    },

    async getCurrencyList() {
      const { default: axios } = await import('axios');
      try {
        const { data: currencyList } = await axios.get(`${path}/currency`);
        this.currencyList = currencyList;
        this.$lcStorage?.set('f7XquQcXg9d7ME', this.currencyList);
        this.getEmoneyApiList();
      } catch (err) {
        console.log(err);
      }
    },

    async getEmoneyApiList() {
      const { default: axios } = await import('axios');
      try {
        const { data: emoneyApiList } = await axios.get(`${path}/emoney/api`);
        this.emoneyApiList = emoneyApiList;
        this.$lcStorage?.set('Jd7Gf5b6H', this.emoneyApiList);
      } catch (err) {
        console.log(err);
      }
    },

    async getCityList() {
      const { default: axios } = await import('axios');
      try {
        const { data: cityList } = await axios.get(`${path}/city`);
        this.cityList = cityList;
      } catch (err) {
        console.log(err);
      }
    },

    async getStateList() {
      const { default: axios } = await import('axios');
      try {
        const { data: stateList } = await axios.get(`${path}/state`);
        this.stateList = stateList;
      } catch (err) {
        console.log(err);
      }
    },

    async getCountryList() {
      const { default: axios } = await import('axios');
      try {
        const { data: countryList } = await axios.get(`${path}/country`);
        this.countryList = countryList;
      } catch (err) {
        console.log(err);
      }
    },

    async loadDestinationCity(payload) {
      const { default: axios } = await import('axios');
      try {
        const country = payload !== null ? payload : this.currentUserCountry;
        const { data: destinationCity } = await axios({
          url: `${path}/country/find`,
          method: 'GET',
          params: { toCountryCode: country },
        });
        this.destinationCity = destinationCity;
      } catch (err) {
        console.log(err);
      }
    },

    async getCurrentUserAddress(payload) {
      const keycloak = useKeycloakStore();
      const { default: axios } = await import('axios');
      try {
        const { data: userAddress } = await axios.get(
          'https://nominatim.openstreetmap.org/reverse',
          {
            params: {
              lat: payload.latitude,
              lon: payload.longitude,
              format: 'json',
            },
          },
        );
        this.userAddress = userAddress;
        const countryCode =
          keycloak.authenticated
            ? keycloak.userInfo.countryCode
            : userAddress.address.country_code;
        this.getCurrentUserCountry(countryCode);
      } catch (err) {
        console.log(err);
      }
    },

    async getCurrentUserIpAddress() {
      const { default: axios } = await import('axios');
      try {
        const { data: response } = await axios.get(
          `https://ipapi.co/json/?key=${import.meta.env.VITE_IPAPI_APIKEY}`,
        );
        this.ipAddress = response.ip;
        this.latitude = response.latitude;
        this.longitude = response.longitude;
        this.getCurrentUserCountry(response.country);
      } catch (err) {
        console.log(err);
      }
    },

    setUserGeolocation(payload) {
      this.latitude = payload.latitude;
      this.longitude = payload.longitude;
    },

    async checkMobilePhone(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: phoneNumberDetail } = await axios({
          url: `${path}/checkPhoneNumber`,
          method: 'GET',
          params: {
            phone: payload.phone,
            countryCode2: payload.countryCode2,
          },
        });
        this.mobilePhoneError = '';
        this.phoneNumberDetail = phoneNumberDetail;
      } catch (err) {
        this.phoneNumberDetail = '';
        this.mobilePhoneError = err.response?.data || '';
        console.log(err);
      }
    },

    async getCurrentUserCountry(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: currentUserCountry } = await axios({
          url: `${path}/userCountry`,
          method: 'GET',
          params: { countryCode2: payload },
        });
        this.currentUserCountry = currentUserCountry;
        const api_code = _.find(
          this.emoneyApiList,
          (api) => api.id === currentUserCountry.countryCode3,
        );
        this.apiCode = api_code;
        if (api_code !== undefined) {
          this.$lcStorage?.set('apiCode', api_code);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
});
